import type { ContentReportCategory } from "api/contentReports";

export type ReportTreeDialogProps = {
	onClose: () => void;
	/** Id of the tree being reported. */
	treeId: string;
	treeTitle: string;
};

export type ReportTreeStatus = "idle" | "submitting" | "success" | "error";

/** Categories in the order they are offered; labels live under `reportDialog.categories`. */
export const REPORT_CATEGORIES: readonly ContentReportCategory[] = [
	"Copyright",
	"Trademark",
	"Impersonation",
	"Privacy",
	"Other"
];
